import React, { useEffect, useState } from "react"
import LayoutAuth from "../components/Layouts/LayoutAuth"
import AuthLoginForm from "../components/Auth/AuthLoginForm"
import { useAuth } from "../hooks/useAuth"

const Title = "Вход в систему"

function Login() {
  const { login, checkAuth, isAuthenticated } = useAuth()
  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    let isMounted = true
    checkAuth(true).finally(() => {
      if (isMounted) {
        setIsChecking(false)
      }
    })
    return () => {
      isMounted = false
    }
  }, [checkAuth])

  const onSubmit = async (
    values: { usernameOrEmail: string; password: string },
    { setSubmitting, setFieldError, setStatus }: any
  ) => {
    setStatus(undefined)
    try {
      await login(values.usernameOrEmail, values.password)
    } catch (error: any) {
      console.error("[Login]: Error logging in:", error)

      if (error.fieldErrors) {
        if (error.fieldErrors.identifier || error.fieldErrors.usernameOrEmail) {
          setFieldError(
            "usernameOrEmail",
            error.fieldErrors.identifier || error.fieldErrors.usernameOrEmail
          )
        }
        if (error.fieldErrors.password) {
          setFieldError("password", error.fieldErrors.password)
        }
      }

      setStatus(
        error.message || "Ошибка авторизации. Проверьте логин и пароль."
      )
      setSubmitting(false)
    }
  }

  if (isChecking || isAuthenticated) {
    return (
      <LayoutAuth title={Title}>
        <div className="py-8 text-center text-sm text-gray-500">
          Проверка активной сессии...
        </div>
      </LayoutAuth>
    )
  }

  return (
    <LayoutAuth title={Title}>
      <AuthLoginForm onSubmit={onSubmit} />
    </LayoutAuth>
  )
}

export default Login
